module.exports = __webpack_public_path__ + "img/rank17.08d55a58.png";